/**
 * Created by intellicar-rinas on 26/6/18.
 */
import React, {Component} from 'react';
import InGraph from '../../../../ReportWindow/schema/InGraph/InGraph2';

export default class Graph extends Component {

    graphConfig = {
        key:'speed',
        graphType: 'graph',
        config:[
            {listenTo:[{key:'value'}], color: "#14ce81", name:'Voltage'},
            {listenTo:[{key:'value'}], color: "#ce6a14", name:'Ampere'},
        ]
    };

    saveState =()=> {};

    getKey =()=> {};

    getGraphConfig =()=> {
        return {
            width: 290,
            height: 160,
            type: this.graphConfig.graphType
        }
    };

    componentDidMount() {

        let starttime;
        let endtime;


        setTimeout(()=> {
            const data = [
                (()=>{
                    let count = 10;
                    let max = 100;
                    let min = 0;
                    let arr = [];
                    starttime = Date.now() - (count * 1000);
                    endtime = Date.now() - 1000;
                    for(let idx=count; idx>0; idx--) {
                        arr.push({
                            value: (Math.random() * max) + min,
                            time: Date.now() - (idx * 1000)
                        })
                    }
                    return arr;
                })(),
                (()=>{
                    let count = 10;
                    let max = 100;
                    let min = 0;
                    let arr = [];
                    starttime = Date.now() - (count * 1000);
                    endtime = Date.now() - 1000;
                    for(let idx=count; idx>0; idx--) {
                        arr.push({
                            value: (Math.random() * max) + min,
                            time: Date.now() - (idx * 1000)
                        })
                    }
                    return arr;
                })(),
            ];
    
            console.log(data);

            this.refs.graph.wrappedInstance.draw({
                data: [data[0]],
                reqTime:Date.now(),
                priority:1,
                axis:0
            }, {
                xDomainValue: [starttime, endtime],
            })
            this.refs.graph.wrappedInstance.draw({
                data: [data[1]],
                reqTime:Date.now(),
                priority:1,
                axis:1
            }, {
                xDomainValue: [starttime, endtime],
            })
        }, 1000)
    }

    componentWillReceiveProps() {
        let times = this.props.voltagehist.map(t => t.time);
        let starttime = Math.min(...times), endtime = Math.max(...times);
        this.refs.graph.wrappedInstance.draw({
            data: [this.props.voltagehist],
            reqTime:Date.now(),
            priority:1,
            axis:0
        }, {
            xDomainValue: [starttime, endtime],
        })
        this.refs.graph.wrappedInstance.draw({
            data: [this.props.amphist],
            reqTime:Date.now(),
            priority:1,
            axis:1
        }, {
            xDomainValue: [starttime, endtime],
        })
    }

    render() {
        return <InGraph   data={this.graphConfig}
        lines={this.graphConfig.config}
                          resume={{}}
                          saveState={this.saveState}
                          schemaKey={this.getKey()}
                          config={this.getGraphConfig()}
                          ref="graph"/>
    }

}